import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { Button } from '../components/ui/button';

// Shown for any address the site doesn't have. The server sends it with a
// real 404 status so search engines drop dead links instead of indexing them.
const NotFound = () => {
  return (
    <div className="min-h-[60vh] bg-gradient-to-b from-white to-cyan-50 flex items-center">
      <SEO
        title="Page not found | Paint It Better"
        description="Sorry, that page isn't here. Find our painting and decorating services in Kent, recent work, or get in touch for a quote."
        noindex
      />
      <div className="container mx-auto px-4 py-16 text-center max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Page not found</h1>
        <p className="text-lg text-slate-600 mb-8">
          Sorry, that page isn't here. It may have moved, or the link may be mistyped.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/"><Button className="bg-cyan-600 hover:bg-cyan-700 text-white rounded-full px-6">Home page</Button></Link>
          <Link to="/services"><Button variant="outline" className="rounded-full px-6">Our services</Button></Link>
          <Link to="/contact"><Button variant="outline" className="rounded-full px-6">Get a quote</Button></Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
